/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class MessengerHistorySyncAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/messenger_history_sync`);
  }

  start(inboxId) {
    return axios.post(`${this.url}/${inboxId}/messenger_history_sync`);
  }
}

export default new MessengerHistorySyncAPI();
